import { render } from "./EqualGrid.vue?vue&type=template&id=7c3a7db4&ts=true"
import script from "./EqualGrid.vue?vue&type=script&lang=ts"
export * from "./EqualGrid.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__